// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__P5nte","pinBottomItem":"styles_pinBottomItem__vqK_f"};